import { RiveContainer } from "./components/RiveContainer";
import { useAnimationRive } from "./hooks/useAnimationRive";
import type { RiveRegistryKey } from "../../assets/animations/riveRegistry/riveRegistry";

type RiveByKeyProps = {
  riveKey?: RiveRegistryKey;
  boxSize?: number;
};

export const RiveByKey = ({ riveKey = "notFound", boxSize = 28 }: RiveByKeyProps) => {
  const { RiveComponent } = useAnimationRive(riveKey);

  return <RiveContainer RiveComponent={RiveComponent} boxSize={boxSize} />;
};

export const CardDemo = () => {
  return <RiveByKey riveKey="free" boxSize={200} />;
};
